module.exports = __webpack_public_path__ + "img/dashboard-landing-intro.7bb643da.svg";